import {
    UPLOAD_POLICY_ASSET_REQUEST,
    UPLOAD_POLICY_ASSET_SUCCESS,
    UPLOAD_POLICY_ASSET_ERROR,
} from '../../../constants/quoteActionNames';

import uploadPolicyAssetApi from '../../../apis/portfolio/uploadPolicyAssetApi';
import uploadFileApi from '../../../apis/dutch/uploadFile';

function uploadPolicyAssetRequest() {
    return { type: UPLOAD_POLICY_ASSET_REQUEST, payload: true };
}

function uploadPolicyAssetSuccess(data, params) {
    return { type: UPLOAD_POLICY_ASSET_SUCCESS, payload: data, params };
}

function uploadPolicyAssetError(err) {
    return { type: UPLOAD_POLICY_ASSET_ERROR, payload: err };
}

export function uploadPolicyAssetAction(params) {
    return (dispatch, getState) => {
        const state = getState();
        dispatch(uploadPolicyAssetRequest());

        const { file, name, description, policyNumber } = params;

        // Step 1: upload the binary to the blob store, get back a URL string
        return uploadFileApi.uploadFile(state, { file, name: file.name })
            .then(uploadResponse => {
                const fileUrl = uploadResponse?.payload;
                // Step 2: attach the blob URL to the policy record
                return uploadPolicyAssetApi.uploadPolicyAsset(state, {
                    policyNumber,
                    name,
                    description,
                    file: fileUrl,
                });
            })
            .then(data => {
                dispatch(uploadPolicyAssetSuccess(data, params));
                return data;
            })
            .catch(error => {
                dispatch(uploadPolicyAssetError(error));
                throw error;
            });
    };
}

export default { uploadPolicyAssetAction };
